import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';

const PayFeeDialog = ({ 
  visible, 
  onHide, 
  payingFee, 
  couponVerified, 
  originalPayableAmount, 
  payableAmount, 
  payingAmount, 
  setPayingAmount, 
  paymentMode, 
  setPaymentMode, 
  handlePayFeeSubmit 
}) => {
  return (
    <Dialog header="Pay Fee" visible={visible}
      onHide={onHide} style={{ width: '500px' }}
      footer={
        <div className="flex justify-between items-center mt-4">
          <Button label="Cancel" icon="pi pi-times" onClick={onHide} className="px-6 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-all duration-200 font-medium" />
          <Button label="Pay" icon="pi pi-check" onClick={handlePayFeeSubmit} className="px-6 py-2 bg-gradient-to-r from-green-600 to-emerald-600 text-white rounded-lg hover:from-green-700 hover:to-emerald-700 transition-all duration-200 font-medium shadow-lg hover:shadow-xl" />
        </div>
      }
      className="rounded-2xl"
    >
      {payingFee && (
        <div className="space-y-6 p-2">
          <div className="grid grid-cols-1 gap-4">
            <div className="flex justify-between items-center bg-gradient-to-r from-blue-50 to-indigo-50 p-4 rounded-xl border border-blue-100">
              <div className="flex items-center mb-2">
                <i className="pi pi-money-bill text-blue-600 mr-2"></i>
                <p className="text-sm font-semibold text-blue-900">Amount</p>
              </div>
              <p className="text-lg font-bold text-gray-900">₹{Number(payingFee.amount || 0).toLocaleString()}</p>
            </div>

            <div className="flex justify-between items-center bg-gradient-to-r from-orange-50 to-red-50 p-4 rounded-xl border border-orange-100">
              <div className="flex items-center mb-2">
                <i className="pi pi-exclamation-triangle text-orange-600 mr-2"></i>
                <p className="text-sm font-semibold text-orange-900">Due Amount</p>
              </div>
              <div className="flex flex-col gap-2">
                {couponVerified ? (
                  <>
                    <p className="text-lg font-bold text-gray-900 line-through text-gray-500">₹{Number(originalPayableAmount || 0).toLocaleString()}</p>
                    <p className="text-lg font-bold text-green-600">₹{Number(payableAmount || 0).toLocaleString()}</p>
                  </>
                ) : (
                  <p className="text-lg font-bold text-gray-900">₹{Number(payingFee.payableAmount || 0).toLocaleString()}</p>
                )}
              </div>
            </div>
            
            <div className="space-y-2">
              <label className="block text-sm font-semibold text-gray-800 flex items-center">
                <i className="pi pi-credit-card mr-2 text-green-600"></i>
                Paying Amount
              </label>
              <InputText value={payingAmount} onChange={(e) => setPayingAmount(Number(e.target.value) || 0)}
                placeholder="Enter payment amount" className="w-full p-3 border border-gray-200 rounded-lg focus:border-green-500 focus:ring-2 focus:ring-green-200 transition-all duration-200 bg-white shadow-sm"/>
            </div> 

            <div className="space-y-2">
              <label className="block text-sm font-semibold text-gray-800 flex items-center">
                <i className="pi pi-wallet mr-2 text-blue-600"></i>
                Payment Mode
              </label>
              <Dropdown value={paymentMode} options={[
                { label: 'Cash', value: 'cash' },
                { label: 'Card', value: 'card' },
                { label: 'UPI', value: 'upi' }
              ]} onChange={(e) => setPaymentMode(e.value)} placeholder="Select payment mode" className="w-full p-1 border border-gray-200 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200 bg-white shadow-sm"/>
            </div> 
          </div>
        </div>
      )}
    </Dialog>
  );
};

export default PayFeeDialog;
